export default "__VITE_ASSET__ChGn2W3I__"